import { Box, Chip,  Typography, LinearProgress, useTheme, Tooltip } from '@mui/material';
import AgGridTable from '../../components/table/AgGridTable';
import { ColDef } from 'ag-grid-community';
import Exclamation from '../../assets/Exclamation.png'
import sparkLogo from '../../assets/Spark-text.svg'
// import csiLogo from '../../assets/cis.png'
import csiLogo from "../../assets/cis_light.svg"
import nistLogo from '../../assets/nist.svg'
import nist_dark from '../../assets/nist_dark.svg';
import spark_dark from '../../assets/spark_dark.svg'
import cis_dark from '../../assets/cis_dark.svg';
import  { useEffect, useState } from 'react';
import axiosInstance from '../../axios/axios';
import { END_POINTS } from '../../shared';
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg";

const RiskAccepted = () => {
    const [loading, setIsLoading] = useState(false);
    const [riskDetails, setRiskDetails] = useState<any[]>([]);
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";

    const riskDetail = async () => {
        try {
            setIsLoading(true);
            // Isolate module failures so cloud outage does not wipe on-prem (and vice versa).
            const [onPremiseResult, cloudResult] = await Promise.allSettled([
                axiosInstance.get(END_POINTS.RISK_ACCEPTANCE_TABLE, {
                    params: { module: "on_premise" },
                }),
                axiosInstance.get(END_POINTS.RISK_ACCEPTANCE_TABLE, {
                    params: { module: "cloud" },
                }),
            ]);

            const mapModuleRows = (result: PromiseSettledResult<any>, module: string) => {
                if (result.status !== "fulfilled") {
                    console.error(`Risk Details Data Fetch Failed (${module})`, result.reason);
                    return [];
                }
                const rows = result.value?.data?.data;
                return Array.isArray(rows)
                    ? rows.map((item: any) => ({ ...item, module }))
                    : [];
            };

            const combinedData = [
                ...mapModuleRows(onPremiseResult, "on_premise"),
                ...mapModuleRows(cloudResult, "cloud"),
            ].filter((item: any) => item.parameter_type !== "Template");
            const sortedData = [...combinedData].sort(
                (a: any, b: any) => (b.accepted_count || 0) - (a.accepted_count || 0)
            );
            setRiskDetails(sortedData);
        } catch (error) {
            console.error("Risk Details Data Fetch Failed", error);
            setRiskDetails([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        riskDetail();
    }, []);

    const columnDefs: ColDef[] = [
        // { field: "id", headerName: "#", maxWidth: 70, valueGetter: (params: any) => params.node.rowIndex + 1 },
        {
            field: "param_name",
            headerName: "Recommendation",
            flex: 0.7,
            minWidth: 200,
            cellRenderer: (params: any) => {
                return (
                    <Tooltip
                        title={params.data.param_name}
                        arrow
                        slotProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    boxShadow: 1,
                                    fontSize: "0.775rem",
                                },
                            },
                            arrow: {
                                sx: {
                                    color: "#fff",
                                },
                            },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                overflow: "hidden",
                                width: "100%",
                                height: "100%",
                            }}
                        >
                            <Typography
                                variant="body2"
                                fontWeight="600"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {params.value}
                            </Typography>
                        </Box>
                    </Tooltip>
                );
            },
            cellStyle: {
                display: "flex",
                alignItems: "center",
            },
        },
        {
            field: "control_type",
            headerName: "Benchmark",
            width: 150,
            cellRenderer: (params: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                    {params.value?.includes('SPARK') && <img src={isDarkMode ? spark_dark : sparkLogo} alt="spark" height="24" />}
                    {params.value?.includes('CIS') && <img src={isDarkMode ? cis_dark : csiLogo} alt="cis" height="24" />}
                    {params.value?.includes('NIST') && <img src={isDarkMode ? nist_dark : nistLogo} alt="nist" height="12" />}
                </Box>
            ),
            cellStyle: {
                display: "flex",
                alignItems: "center",
            },
        },
        {
            field: "highest_priority",
            headerName: "Severity",
            width: 200,
            cellRenderer: (params: any) => {
                const severityStyles: any = {
                    Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Chip
                            label={params.value}
                            size="small"
                            sx={{
                                bgcolor: severityStyles[params.value]?.bgcolor || '#f5f5f5',
                                color: severityStyles[params.value]?.color || '#666666',
                                height: '20px',
                                borderRadius: '4px',
                                position: 'relative',
                                fontWeight: 600,
                                p: 1.5,
                                pr: 0,
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    left: 8,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: 8,
                                    height: 8,
                                    bgcolor: severityStyles[params.value]?.color || '#666666',
                                    borderRadius: '50%'
                                },
                                '& .MuiChip-label': { px: 1 }
                            }}
                        />
                    </Box>
                );
            },
            cellStyle: {
                display: "flex",
                alignItems: "center",
            },
        },
        {
            field: "accepted_count",
            headerName: "Risk Accepted",
            maxWidth: 150,
            sort: 'desc',
            sortIndex: 0,
            cellRenderer: (params: any) =>
                params.value > 0 ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: '100%' }}>
                        <img src={Exclamation} alt="exclamation" height="20" />
                        <Typography variant="body2" fontWeight={600}>{params.value}</Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: "flex", alignItems: "center", height: '100%' }}>
                        <img src={AcceptedRisk_False} alt="warning" style={{ height: "20px" }} />
                    </Box>
                ),
            cellStyle: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
            },
        },
        {
            field: "asset_passed_percent",
            headerName: "Assets",
            width: 200,
            cellRenderer: (params: any) => {
                const passedCount = params.data.passed_asset_count;
                const totalCount = params.data.total_asset_count;
                const progressValue = Math.round(params.value) || 0;

                return (
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', pr: '8px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography variant="caption">{`${passedCount}/${totalCount} (${progressValue}%)`}</Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={progressValue}
                            sx={{
                                height: 6,
                                borderRadius: 3,
                                bgcolor: '#f5f5f5',
                                '& .MuiLinearProgress-bar': {
                                    bgcolor: '#4caf50'
                                }
                            }}
                        />
                    </Box>
                );
            },
            cellStyle: {
                display: "flex",
                alignItems: "center",
            },
        }
    ];

    return (
        // <Card sx={{
        //     boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
        //     // borderRadius: 2,
        //     height: '100%'
        // }}>
       <AgGridTable
  columnDefs={columnDefs}
  height={'calc(100vh - 78px)'}
  data={riskDetails.filter((row) => row.accepted_count > 0)}  
  showSearch
  isLoading={loading}
/>
        // </Card>
    );
};

export default RiskAccepted;
